import { EldmlTransform } from "./EldmlTransform";
import $ from "jquery";

export class RenderTransform extends EldmlTransform {
  apply() {
    $("[rendered]").each((_, e) => {
      const element = $(e);
      const rendered = element.attr("rendered")?.toLowerCase() ?? "true";
      if (rendered === "false") {
        element.css("display", "none");
      }
    });
  }
}
